import { currencies, Currency } from '~/constants/currency';
import * as moment from 'moment';
import { TranslationFunction } from '~/utils/translate';

enum InvoiceStatus {
  OPEN = 'OPEN',
  READY_FOR_CHARGE = 'READY_FOR_CHARGE',
  PAYMENT_INITIATED = 'PAYMENT_INITIATED',
  PAID = 'PAID',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  WRITTEN_OFF = 'WRITE_OFF',
  READY_FOR_CHARGE_CONVERSION = 'READY_FOR_CHARGE_CONVERSION',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
}

type JSONInvoice = {
  object_id: Maybe<string>;
  object_created: string;
  number: Maybe<string>;
  total_currency: Maybe<string>;
  total_amount: Maybe<string>;
  paid: Maybe<string>;
  status: string;
  error_type: Maybe<string>;
};

type Invoice = {
  objectId: Maybe<string>;
  objectCreated: moment.Moment;
  invoiceNumber: Maybe<string>;
  totalCurrency: Maybe<Currency>;
  totalAmount: Maybe<string>;
  paid: Maybe<moment.Moment>;
  status: InvoiceStatus;
  errorType: Maybe<string>;
};

function fromJSON(jsonInvoice: JSONInvoice): Invoice {
  return {
    objectId: jsonInvoice.object_id,
    objectCreated: moment(jsonInvoice.object_created),
    invoiceNumber: jsonInvoice.number || null,
    totalCurrency: jsonInvoice.total_currency ? currencies[jsonInvoice.total_currency] : null,
    totalAmount: jsonInvoice.total_amount || null,
    paid: jsonInvoice.paid ? moment(jsonInvoice.paid) : null,
    status: <InvoiceStatus>jsonInvoice.status,
    errorType: jsonInvoice.error_type || null,
  };
}

function getPaymentFailureText(t: TranslationFunction, errorType: string): string {
  let customerFacingError;
  const translationPrefix = 'account.billing.invoices.table.cells.error';
  switch (String(errorType).toLowerCase()) {
    case 'payment_declined':
      customerFacingError = t(`${translationPrefix}.paymentDeclined`);
      break;
    case 'unsupported_currency':
      customerFacingError = t(`${translationPrefix}.unsupportedCurrency`);
      break;
    case 'duplicate_transaction':
      customerFacingError = t(`${translationPrefix}.duplicateTransaction`);
      break;
    case 'expired_card':
      customerFacingError = t(`${translationPrefix}.expiredCard`);
      break;
    case 'incorrect_card_details':
      customerFacingError = t(`${translationPrefix}.incorrectCardDetails`);
      break;
    case 'insufficient_funds':
      customerFacingError = t(`${translationPrefix}.insufficientFunds`);
      break;
    case 'temporary_error':
      customerFacingError = t(`${translationPrefix}.temporaryError`);
      break;
    case 'use_alternate_method':
      customerFacingError = t(`${translationPrefix}.useAlternateMethod`);
      break;
    default:
      customerFacingError = t(`${translationPrefix}.paymentDeclined`);
  }

  return customerFacingError;
}

export default Invoice;
export { fromJSON, Invoice, InvoiceStatus, JSONInvoice, getPaymentFailureText };
